import React from 'react';

import { FullBleedHero } from './variations/fullBleed';
import { HorizontalAlignHero } from './variations/horizontalAlign';
import { NoImageHero } from './variations/noImage';

export function Hero(props) {
  const {
    abTestId,
    imageAlignment,
    textColor
  } = props;

  const moduleType = imageAlignment || 'fullBleed';

  const IMAGE_ALIGNMENT_VARIATIONS = {
    fullBleed: FullBleedHero,
    rightAligned: HorizontalAlignHero,
    leftAligned: HorizontalAlignHero,
    noImage: NoImageHero
  };

  const HeroVariation = IMAGE_ALIGNMENT_VARIATIONS[moduleType] || null;

  return (
    <section
      className={textColor}
      id={abTestId}
    >
      <HeroVariation {...props} />
    </section>
  );
};
